import React from "react";
import { CHAPTERS, DEVICES } from "../../constants/literary_devices";
import Select from "../shared/Select";

const Filters = ({
  currentFilter,
  setCurrentFilter,
  filterOptions,
  setViewMode,
  hideFilters,
  viewMode,
  sectionType
}) => {
  if (hideFilters) {
    return null;
  }

  const setViewModeToChapters = () => {
    setViewMode(CHAPTERS);
  };

  const setViewModeToDevices = () => {
    setViewMode(DEVICES);
  };

  const onChangeFilter = (option) => {
    setCurrentFilter(option);
  };

  return (
    <div id="anchor">
      <div className="literary-devices filters">
        <div className="options-container">
          <span>Sort by: </span>
          <button
            className={`btn sort-by-option ${
              viewMode === DEVICES ? "sort-by-option--active" : ""
            }`}
            onClick={setViewModeToDevices}
            type="button"
          >
            <span className="btn-text">Devices A-Z</span>
          </button>
          <button
            className={`btn sort-by-option ${
              viewMode === CHAPTERS ? "sort-by-option--active" : ""
            }`}
            onClick={setViewModeToChapters}
            type="button"
          >
            <span className="btn-text">{sectionType}</span>
          </button>
        </div>
        <Select
          isControlled
          id="literary-devices-filter"
          name="literary-devices-filter"
          options={filterOptions}
          onChange={onChangeFilter}
          value={currentFilter.value}
        />
      </div>
    </div>
  );
};

export default Filters;
